export const actionTypes = {
    PREVENT_INTERACTION: 'MOBILE/PREVENT_INTERACTION',
    ENABLE_INTERACTION: 'MOBILE/ENABLE_INTERACTION',
    SET_BASE_MAP: 'MOBILE/SET_BASEMAP',
    SHOW_LOADING_SPINNER: 'MOBILE/SHOW_LOADING_SPINNER',
    BEGIN_MOBILE_SENTINEL_SEARCH: 'MOBILE/BEING_MOBILE_SENTINEL_SEARCH',

};